import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    errorLabel: {
        fontWeight: "bold",
        color: "red",
        minWidth: 155
    },
    inputLabel: {
        fontWeight: "bold",
        color: "#002F36",
        minWidth: 155,
        "& .Mui-focused": {
            color: "#002F36"
        }
    },
    inputField: {
        minWidth: 270,
        border: "1.5px solid #333333",
        height: "calc(1.5em + .75rem + 2px)",
        borderRadius: 4,
        textAlign: "center",
        "& .MuiInputBase-root": {
            color: "#495057"
        },
        "& .MuiInputBase-input": {
            textAlign: "center",
            padding: "8px 7px 7px",
        },
        "& .MuiOutlinedInput-input": {
            padding: "20.5px 14px 14px"
        },
        "& .MuiInput-underline:before": {
            borderBottom: "0 !important"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "0 !important"
        },
        '&::placeholder': {
            color: '#495057 !important'
        }
    }
});